import React, { useCallback, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

// Import Swiper styles
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import 'swiper/modules/navigation/navigation.min.css'

import SwiperCore, {
    Pagination,
    Navigation
} from 'swiper';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
import useApi from '../../hooks/useApi';
import { Onboarding } from '../../types/Onboarding';
import { SpinnerLoad } from '../Loading/SpinnerLoad';


SwiperCore.use([Navigation, Pagination]);

export const HomeSlider = () => {

    const [load, setLoad] = useState<boolean>(false)
    const [onboadirgs, setOnboardings] = useState<Onboarding[]>()
    const api = useApi()

    const loadOnboarding = useCallback(async () => {
        setLoad(true)
        await api.get("/client/onboarding").then(res => {
            setOnboardings(res.data)
        }).catch(console.log)
        setLoad(false)
    }, [api])

    useEffect(() => {
        loadOnboarding()
    }, [loadOnboarding])

    return (
        <div className=''>
            {!load &&
            <Swiper
                freeMode={true}
                slidesPerView={1}
                modules={[Navigation, Pagination]}
                navigation={{
                    prevEl: '.omboarding-prev',
                    nextEl: '.omboarding-next',

                }}
                pagination={{
                    el: '.pagination',
                    type: 'bullets',
                }}
                autoplay={{
                    delay: 5000,
                }}
                className="mySwiper h-80  rounded bg-green-600">
                {onboadirgs?.map(item => (
                    <SwiperSlide key={item.id} className='flex flex-col justify-between p-5' style={{
                        backgroundImage: `url(${item.banner})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "auto 100%",
                        backgroundPosition: "center"
                    }}>
                        <div className='text-white font-semibold text-lg'>{item.title}</div>
                        <div className='text-white'>{item.description}</div>
                    </SwiperSlide>
                ))}
            </Swiper>
            }
            {load && <SpinnerLoad />}
            <div className='flex justify-between my-2  items-center'>
                <div>
                    <div className='pagination flex gap-x-1'></div>
                </div>
                <div className='flex'>
                    <div className='omboarding-prev prev-slide' ><FaArrowAltCircleLeft className='text-blue-700  text-lg mr-1' /></div>
                    <div className='omboarding-next next-slide' ><FaArrowAltCircleRight className='text-blue-700 text-lg ' /></div>
                </div>
            </div>


        </div>
    )
}